import ltk from "./window._ltk";
import ltk_util from "./window._ltk_util";

const listrakRegister = (d: Function) => {
  if (typeof ltk === "undefined") {
    if (document.addEventListener)
      document.addEventListener("ltkAsyncListener", () => {
        ltk_util.ready(d);
      });
  } else {
    ltk_util.ready(d);
  }
};

export default listrakRegister;
export { listrakRegister };
